import React, { Component } from 'react'

import CollapsableComponent from '../components/CollapsableComponent'

import '../collapsableStyle.css'

class CollapsableContainer extends Component {
  handlerButton = (pos) => {
    const coll = document.getElementsByClassName("collapsible-button")
    for (let i = 0; i < coll.length; i++) {
      if(i !== pos){
        if (coll[i].classList.contains('collapsible-active')) {
          const open = document.getElementsByClassName("collapsible-active")
          for (let j = 0; j < open.length; j++) {
            open[j].nextElementSibling.style.maxHeight = null;
            open[j].classList.remove("collapsible-active")
          }
        }
      }
    }
    coll[pos].classList.toggle("collapsible-active");
    let content = coll[pos].nextElementSibling;
    if (content.style.maxHeight) {
      content.style.maxHeight = null;
    } else {
      content.style.maxHeight = content.scrollHeight + "px";
    }
  }

  render() {
    return (
      <CollapsableComponent content={this.props.content} handlerButton={this.handlerButton} />
    )
  }
}

export default CollapsableContainer